/* eslint-disable */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _queryString = _interopRequireDefault(require("query-string"));

require("isomorphic-ws");

var _debug = _interopRequireDefault(require("debug"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var debugPeer = (0, _debug.default)('MEWconnectVerbose:websocketWrapper');
var debug = (0, _debug.default)('MEWconnect:websocketWrapper');

var WebsocketConnection = /*#__PURE__*/function () {
  function WebsocketConnection() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, WebsocketConnection);

    this.options = options;
    this.socket = {};
    this.listeners = {};
    this.SOCKET_STATES = {
      0: 'CONNECTING',
      1: 'OPEN',
      2: 'CLOSING',
      3: 'CLOSED'
    };
    this.keepAlive = {
      ping: 'ping',
      pong: 'pong'
    };
  }
  /**
   * Connect to a given @websocketURL with given @options query params.
   * The client will connect and bind every on "message" event to the
   * onMessage() function.
   *
   * In order to handle a message, the on() member function must be used to add
   * an listener. This gives functionality similar to socket.io, in which
   * it is possible to so something like:
   *
   * socket.on('error', err => {})
   * as opposed to:
   * socket.on('message', message => { if (message.signal === 'error')... })
   *
   * @param  {String} websocketURL - WSS address of websocket API
   * @param  {Object} options - JSON-formatted connection query params
   * @param  {String} options.role - Either "initiator" or "receiver" accordingly
   * @param  {String} options.connId - Last 32 characters of the public key portion of the key-pair
   *                                  created for the particular paired connection
   * @param  {String} options.signed - Private key signed with the private key created for the connection
   */


  _createClass(WebsocketConnection, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(websocketUrl) {
        var options,
            url,
            _WebSocket,
            _args = arguments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.prev = 1;
                url = "".concat(websocketUrl, "?").concat(_queryString.default.stringify(options));
                debug(url);

                if (!(typeof jest !== 'undefined' && typeof window === 'undefined')) {
                  _context.next = 12;
                  break;
                }

                _WebSocket = require('promise-ws').default;
                _context.next = 8;
                return _WebSocket.create(url);

              case 8:
                this.socket = _context.sent;
                this.socket.on('message', this.onMessage.bind(this));
                _context.next = 20;
                break;

              case 12:
                this.socket = new WebSocket(url);
                this.socket.onmessage = this.onMessage.bind(this);
                this.socket.onerror = this.onError.bind(this);
                this.socket.onopen = this.onOpen.bind(this);
                this.socket.onclose = this.onClose.bind(this);
                debug("extensions used: ".concat(this.socket.extensions, " or none"));
                debug("protocol used: ".concat(this.socket.protocol, " or default"));
                debug("binary type used: ".concat(this.socket.binaryType, " [either blob or arraybuffer]"));

              case 20:
                _context.next = 25;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](1);
                debug('connect error:', _context.t0);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 22]]);
      }));

      function connect(_x) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  debug('ADD DISCONNECT FUNCTIONALITY');
                  this.socket.close();
                } catch (e) {
                  debug('disconnect error:', e);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "getSocketState",
    value: function getSocketState() {
      return this.SOCKET_STATES[this.socket.readyState];
    }
  }, {
    key: "onOpen",
    value: function onOpen() {
      debug("websocket onopen = ".concat(this.getSocketState())); // this.pinger = setInterval(() => {
      //   this.send(this.keepAlive.ping)
      // }, 5000)
    }
    /**
     * On 'message' event, parse the message and if possible,
     * call the event listener with the message's particular signal.
     *
     * Messages are received as stringified JSON objects, that when parsed,
     * take the following format:
     *
     * {
     *   signal, // This is the signal that the member function on() can bind to
     *   data, // The actual data payload
     *   message // Accompanying server message
     * }
     *
     * @param  {String} message - Stringified JSON payload sent by the server
     * @return {[type]}         [description]
     */

  }, {
    key: "onMessage",
    value: function onMessage(message) {
      try {
        debugPeer('message', message);
        debugPeer('message data', message.data);
        var parsedMessage;

        if (typeof jest === 'undefined') {
          var parsedMessageRaw = typeof message === 'string' ? JSON.parse(message) : message;
          parsedMessage = typeof parsedMessageRaw.data === 'string' ? JSON.parse(parsedMessageRaw.data) : parsedMessageRaw.data;
          debugPeer('parsedMessage', parsedMessage);
        } else {
          parsedMessage = typeof message === 'string' ? JSON.parse(message) : message;
          debugPeer('parsedMessage: message', parsedMessage);
          debugPeer('parsedMessage: message data', parsedMessage.data);
        }

        if (parsedMessage.signal === 'ping' || parsedMessage.signal === 'pong') {
          return;
        }

        var signal = parsedMessage.signal;
        var data = parsedMessage.data;
        debug("onMessage Signal: ".concat(signal));

        try {
          this.listeners[signal].call(this, data);
        } catch (e) {
          debug(e); // Unhandled message signal
        }
      } catch (e) {
        debug('ERROR in onMessage', e);
      }
    }
  }, {
    key: "onError",
    value: function onError(errorEvent) {
      debug('Websocket ERROR');
      debug('websocket error event', errorEvent);
    }
  }, {
    key: "onClose",
    value: function onClose() {
      debug("websocket onClose = ".concat(this.getSocketState()));

      if (this.listeners['onClose']) {
        this.listeners['onClose'].call(this);
      }
    }
    /**
     * Bind an function to a particular message signal event.
     * E.G.
     * socket.on('error', err => {})
     *
     * @param  {String} signal - The signal to listen for
     * @param  {Function} fn - Function to perform on message signal
     */

  }, {
    key: "on",
    value: function on(signal, fn) {
      this.listeners[signal] = fn;
    }
    /**
     * Unbind a particular message signal event listener.
     *
     * @param  {String} signal - The signal to unbind
     */

  }, {
    key: "off",
    value: function off(signal) {
      delete this.listeners[signal];
    }
    /**
     * Send a data payload to a particular signal.
     *
     * @param  {String} signal - Particular action/signal such as "offersignal"
     * @param  {[type]} data - Data payload
     */

  }, {
    key: "send",
    value: function send(signal) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      try {
        debug("socket connection state: ".concat(this.getSocketState()));
        debug("send signal: ".concat(signal));
        debug('send data:', data);
        var message = JSON.stringify({
          action: signal,
          data: data
        });
        this.socket.send(message);
      } catch (e) {
        debug('ERROR in send', e);
      }
    }
  }]);

  return WebsocketConnection;
}();

exports.default = WebsocketConnection;